import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pagination-new flex flex--v flex--valign-c flex--gap-20" }
const _hoisted_2 = {
  key: 0,
  class: "pagination-new-nav flex flex--valign-c flex--gap-10"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "pagination-button-text pagination-button-text--arrow text text--accent-gray-a text--size-40 text--bold" }, /*#__PURE__*/_toDisplayString("<"), -1)
const _hoisted_4 = { class: "pagination-buttons-inner flex flex--valign-c flex--gap-0" }
const _hoisted_5 = { class: "pagination-button-text text text--accent-gray-a text--size-22 text--medium" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "pagination-button-text pagination-button-text--arrow text text--accent-gray-a text--size-40 text--bold" }, /*#__PURE__*/_toDisplayString(">"), -1)
const _hoisted_7 = { class: "pagination-count text text--size-18 text--primary-b text--medium text--center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.paginationData.last_page > 1)
      ? (_openBlock(), _createBlock("nav", _hoisted_2, [
          _createVNode("button", {
            class: "pagination-button",
            disabled: _ctx.isFirstPage,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1)))
          }, [
            _hoisted_3
          ], 8, ["disabled"]),
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
              return (_openBlock(), _createBlock("button", {
                key: page.key,
                class: ["pagination-button", { active: page.page === _ctx.currentPage, dots: page.isDots }],
                disabled: page.isDots,
                onClick: ($event: any) => (_ctx.goToPage(page.page))
              }, [
                _createVNode("span", _hoisted_5, _toDisplayString(page.label), 1)
              ], 10, ["disabled", "onClick"]))
            }), 128))
          ]),
          _createVNode("button", {
            class: "pagination-button",
            disabled: _ctx.isLastPage,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1)))
          }, [
            _hoisted_6
          ], 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$trans("main.pagination-count", { args: { from: _ctx.paginationData.from, to: _ctx.paginationData.to, records: _ctx.paginationData.total } })), 1)
  ]))
}